import * as normalize from 'utils/normalize';

import getPatientName from 'utils/print/getPatientName';
import getPatientRecordNumber from 'utils/print/getPatientRecordNumber';
import getSignature from 'utils/print/getSignature';
import getBusinessName from 'utils/print/getBusinessName';
import getFacilityName from 'utils/print/getFacilityName';
import getBusinessStreet from 'utils/print/getBusinessStreet';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getBusinessCityStateZip from 'utils/print/getBusinessCityStateZip';
import getFacilityCityStateZip from 'utils/print/getFacilityCityStateZip';
import getBusinessPhone from 'utils/print/getBusinessPhone';
import getFacilityPhone from 'utils/print/getFacilityPhone';
import getBusinessFax from 'utils/print/getBusinessFax';
import getFacilityFax from 'utils/print/getFacilityFax';
import getSignatureDate from 'utils/print/getSignatureDate';

const DeliveryTicketIntegra = {
  ID: 19,
  Name: 'Inspection / Repair',
  Type: 'Assessment Form',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Delivery-Ticket-Inspection-Repair/1.js',
      Logo: {
        x: 26,
        y: 17,
        width: 60,
        height: 25,
      },
      texts: [
        {
          name: 'Business Name',
          getText: props => getFacilityName(props) || getBusinessName(props),
          x: 108,
          y: 7,
          align: 'center',
          fontStyle: 'italic',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Street',
          getText: props => getFacilityStreet(props) || getBusinessStreet(props),
          x: 153,
          y: 22,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business City State Zip',
          getText: props => getFacilityCityStateZip(props) || getBusinessCityStateZip(props),
          x: 153,
          y: 25,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Phone',
          getText: props => getFacilityPhone(props) ? `Tel: ${getFacilityPhone(props)}` : `Tel: ${getBusinessPhone(props)}`,
          x: 153,
          y: 28,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Fax',
          getText: props => getFacilityFax(props) ? `Fax: ${getFacilityFax(props)}` : `Fax: ${getBusinessFax(props)}`,
          x: 153,
          y: 31,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
      ],
      fields: [
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 44,
          y: 54.5,
          width: 92,
        },
        {
          name: 'Patient Acct',
          type: 'text',
          getValue: getPatientRecordNumber,
          x: 153,
          y: 54.5,
          width: 44,
        },
        {
          name: 'Device',
          type: 'text',
          x: 33,
          y: 63,
          width: 63,
        },
        {
          name: 'Serial',
          type: 'text',
          x: 113,
          y: 63,
          width: 84,
        },
        {
          name: 'Model',
          type: 'text',
          x: 33,
          y: 72,
          width: 63,
        },
        {
          name: 'Mfr',
          type: 'text',
          x: 113,
          y: 72,
          width: 84,
        },
        {
          name: 'Date 1',
          type: 'text',
          x: 33,
          y: 82,
          width: 63,
          normalize: normalize.date,
        },
        {
          name: 'Inspector',
          type: 'text',
          x: 113,
          y: 82,
          width: 84,
        },
        {
          name: 'Services Type',
          type: 'radio',
          options: [
            {
              x: 33.5,
              y: 90.25,
              width: 3,
              height: 3,
              value: 'Inspection',
            },
            {
              x: 62,
              y: 90.25,
              width: 3,
              height: 3,
              value: 'Preventive Maintenance',
            },
            {
              x: 108,
              y: 90.25,
              width: 3,
              height: 3,
              value: 'Repair',
            },
          ],
        },
        ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].reduce((accumulator, currentValue) => {
          const y = 106.5 + (currentValue * 6.87);
          return [
            ...accumulator,
            {
              name: `IF DEVICE IS ELECTRICAL USE ORTHOPEDIC INSPECTION/REPAIR FORM ${currentValue}`,
              type: 'radio',
              options: [
                {
                  x: 105,
                  y: y + 2.5,
                  width: 4,
                  height: 4,
                  value: 'Yes',
                },
                {
                  x: 128,
                  y: y + 2.5,
                  width: 4,
                  height: 4,
                  value: 'No',
                },
              ],
            },
            {
              name: `IF DEVICE IS ELECTRICAL USE ORTHOPEDIC INSPECTION/REPAIR FORM Actions Taken ${currentValue}`,
              type: 'text',
              x: 143,
              y,
              width: 53,
              height: 8.5,
              multiline: true,
            },
          ];
        }, []),
        {
          name: 'IF DEVICE IS ELECTRICAL USE ORTHOPEDIC INSPECTION/REPAIR FORM Custom',
          type: 'text',
          x: 19,
          y: 177.5,
          width: 76,
        },
        {
          name: 'List Problem/If in for Repair',
          type: 'text',
          x: 19,
          y: 187,
          width: 177,
          height: 17.5,
          multiline: true,
        },
        {
          name: 'Services Performed',
          type: 'text',
          x: 19,
          y: 208,
          width: 177,
          height: 17.5,
          multiline: true,
        },
        {
          name: 'Services Result',
          type: 'radio',
          options: [
            {
              x: 35.25,
              y: 231,
              width: 3,
              height: 3,
              value: 'Sent back to inventory',
            },
            {
              x: 81.75,
              y: 231,
              width: 3,
              height: 3,
              value: 'Sent back to Manufactruer',
            },
            {
              x: 132.5,
              y: 231,
              width: 3,
              height: 3,
              value: 'Incident',
            },
          ],
        },
        {
          name: 'Signature of Patient or Patients Representative',
          type: 'signature',
          getValue: getSignature,
          x: 56,
          y: 245,
          width: 60,
          height: 18,
        },
        {
          name: 'Date 2',
          type: 'text',
          getValue: getSignatureDate,
          x: 136,
          y: 258,
          width: 39,
          normalize: normalize.date,
        },
      ],
    },
  ],
};

export default DeliveryTicketIntegra;



// WEBPACK FOOTER //
// ./src/config/documents/Delivery-Ticket-Inspection-Repair.js